import { ApiService } from "../../constants/ApiService";
import { HttpService } from "../../constants/HTTPService";
import { CreateFormDto, FormListEntity } from "./Entity";
import { DeleteFormDto } from "./Entity/DeleteFormDto";
import { FormEntity } from "./Entity/FormEntity";
import { GetFormListDto } from "./Entity/GetFormListDto";
import { UpdateFormDto } from "./Entity/UpdateFormDto";

export const createForm = async (payload: CreateFormDto): Promise<boolean> => {
  try {
    await HttpService.post(
      ApiService.form.createForm,
      JSON.stringify(CreateFormDto.toJSON(payload))
    );
    return true;
  } catch (error) {
    console.error("Error creating form:", error);
    throw new Error("Failed to create form");
  }
};

export const getFormList = async (
  payload: GetFormListDto
): Promise<FormListEntity[]> => {
  try {
    const response = await HttpService.post(
      ApiService.form.getForm,
      JSON.stringify(payload)
    );
    return FormListEntity.fromJSON(response.data.data);
  } catch (error) {
    console.error("Error fetching form:", error);
    throw new Error("Failed to fetch form");
  }
};

export const deleteForm = async (payload: DeleteFormDto): Promise<boolean> => {
  try {
    await HttpService.post(ApiService.form.deleteForm, JSON.stringify(payload));
    return true;
  } catch (error) {
    console.error("Error deleting form:", error);
    throw new Error("Failed to delete form");
  }
};

export const getFormDetail = async (id: string): Promise<FormEntity> => {
  try {
    const response = await HttpService.get(`${ApiService.form.getForm}/${id}`);
    return FormEntity.fromJSON(response.data.data);
  } catch (error) {
    console.error("Error fetching form:", error);
    throw new Error("Failed to fetch form detail");
  }
};

export const updateForm = async (payload: UpdateFormDto): Promise<boolean> => {
  try {
    await HttpService.post(
      ApiService.form.updateForm,
      JSON.stringify(UpdateFormDto.toJSON(payload))
    );
    return true;
  } catch (error) {
    console.error("Error updating form:", error);
    throw new Error("Failed to update form");
  }
};
